import "@fontsource/ibm-plex-sans/300-italic.css";
import "@fontsource/ibm-plex-sans/300.css";
import "@fontsource/ibm-plex-sans/400-italic.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500-italic.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600-italic.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700-italic.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/literata/300.css";
import "@fontsource/literata/400.css";
import "@fontsource/literata/700.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { ApiClientsProvider } from "@garther/query-hooks";
import { GartherToaster, createQueryClient } from "@garther/ui/libs";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { initAuthListeners } from "./features/auth/auth.store";
import "./global.css";
import { routeTree } from "./routeTree.gen";
import { initAnalytics } from "./shared/libs/analytics";
import {
  bookingApiClient,
  creditApiClient,
  eventsApiClient,
  inviteApiClient,
  mapApiClient,
  orgApiClient,
  profileApiClient,
  publicApiClient,
  quizApiClient,
  referralApiClient,
  ticketApiClient
} from "./shared/libs/api";
import "./shared/libs/i18n";

const queryClient = createQueryClient();
const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  // Initialize analytics
  initAnalytics();

  // Initialize auth listeners
  const cleanupAuthListeners = initAuthListeners();

  const AppContent = (
    <QueryClientProvider client={queryClient}>
      <ApiClientsProvider
        queryClient={queryClient}
        clients={{
          eventsApiClient,
          bookingApiClient,
          ticketApiClient,
          creditApiClient,
          profileApiClient,
          quizApiClient,
          referralApiClient,
          orgApiClient,
          inviteApiClient,
          mapApiClient,
          publicApiClient
        }}
      >
        <RouterProvider router={router} />
        <GartherToaster />
      </ApiClientsProvider>
    </QueryClientProvider>
  );

  root.render(<StrictMode>{AppContent}</StrictMode>);

  // Cleanup auth listeners when app unmounts
  window.addEventListener("beforeunload", cleanupAuthListeners);
}
